import Box from '@mui/material/Box';

import { FileAttachment } from '~hooks/useFileAttachment/models';

import { columns, gridTemplateColumns } from './all-files-table-columns';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

interface AllFilesTableProps {
  files: FileAttachment[];
}

export default function AllFilesTable({ files }: AllFilesTableProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoRows: 'auto',
        gridTemplateColumns,
        gridTemplateRows: '35px',
      }}
    >
      {columns.map((column) => (
        <TableHeader key={column.key} title={column.title} sx={column.sx} />
      ))}

      {files.map((file) => (
        <TableRow key={file.id} file={file} />
      ))}
    </Box>
  );
}
